import styled, { css, keyframes } from 'styled-components'

import { FlexCentered, FullWidthHeight } from 'components/common/genericStyles'

const avatarFadeOut = ({ start }) => keyframes`
    0%{
        bottom: ${start}%;
        opacity: 1;
    }

    100%{
        bottom: 75%;
        opacity: 0;
        display: none;
    }
`

export const squareCustomCss = {
    area: css`
        opacity: 1;
        border-radius: 50%;
        margin-bottom: 10%;
        position: absolute;
        overflow: hidden;
        animation: 0.8s linear
            ${avatarFadeOut({
                start: 17,
            })}
            forwards;
        animation-iteration-count: 1;
    `,
    wrapper: css`
        ${FlexCentered}
    `,
}

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    padding-bottom: 17%;
    display: flex;
    overflow: hidden;
    align-items: flex-end;
    flex-direction: column-reverse;
    border-radius: inherit;
    opacity: 1;
`

export const AvatarWrapper = styled.div`
    ${FullWidthHeight}
    max-width: 40px;
    max-height: 40px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    margin-bottom: 10%;
    overflow: hidden;
    background: ${props =>
        props.isTeacher ? 'rgb(177,221,213)' : 'rgb(4, 108, 192)'};
`
